<template>

    <router-view
        v-if="loaded"
        @updateContractdata="fetchHrUserContracts"
    ></router-view>

</template>

<script>

import axios from 'axios';
import { mapGetters, mapActions } from "vuex";

export default {

    computed:{
        ...mapGetters([
            'getHrUser',
            'getHrUserContracts',
        ]),
    },

    data() {
        return {
            loaded:false,
        }
    },

    destroyed(){
        this.setHrUserContracts([]);
    },

    metaInfo: {
        title:'Contracten bekijken',
    },

    methods: {
        ...mapActions([
            'setHrUserContracts',
        ]),

        checkHrUserContracts() {
            if (this.getHrUserContracts.length === 0) {
                this.fetchHrUserContracts();
            } else {
                this.loaded = true;
            }
        },

        fetchHrUserContracts() {
            axios.get(this.route('api.v1.hr.users.contracts.index', {id: this.getHrUser.uuid}))
            .then(resp => {
                this.setHrUserContracts(resp.data.data);
                this.loaded = true;
            });
        },
    },

    mounted(){
        this.checkHrUserContracts();
    },

    name:'HrUsersContractsLayout',

}

</script>
